import { FloatingFormItem, InputDate } from '@/components/_common';
import {
  useWorkOrderChecklistFutureServiceCreate,
  useWorkOrderChecklistFutureServiceEdit,
} from '@/core/domain/workorder/WorkOrdersChecklist/WorkOrdersChecklist.hooks';
import { WorkOrderChecklistFutureService } from '@/core/domain/workorder/WorkOrdersChecklist/WorkOrdersChecklist.types';
import { useDefaultEmptyFieldError } from '@/hooks';
import { DateTimeFormat } from '@/utils/moment';
import { Col, Form, Input, Modal, ModalProps, Row } from 'antd';
import moment, { Moment } from 'moment';
import { useEffect } from 'react';
import { useWorkorderChecklistContext } from '../../WorkorderChecklistProvider';
import { WorkorderChecklistItemType } from '../../WorkorderChecklistProvider/WorkorderChecklistProvider.types';

interface Props extends ModalProps {
  onCancel: () => void;
  futureService?: WorkOrderChecklistFutureService;
}

type FormValues = {
  date: Moment;
  description: string;
};

const ChecklistFutureServiceModalForm: React.FC<Props> = ({
  futureService,
  ...props
}) => {
  const title = `${futureService ? 'Editar' : 'Criar'} Serviço futuro`;
  const [form] = Form.useForm<FormValues>();
  const ruleRequired = useDefaultEmptyFieldError();
  const { checklistItemId, checklistItemType } = useWorkorderChecklistContext();

  const futureServiceCreate = useWorkOrderChecklistFutureServiceCreate();
  const futureServiceEdit = useWorkOrderChecklistFutureServiceEdit();

  useEffect(() => {
    if (futureService) {
      form.setFieldsValue({
        date: moment(futureService.date),
        description: futureService.description,
      });
    }
  }, [futureService]);

  async function handleSubmit() {
    try {
      const values = await form.validateFields();
      const obj = { ...values, date: values.date.format(DateTimeFormat) };

      if (futureService) {
        await futureServiceEdit.mutateAsync({ ...obj, id: futureService.id });
      } else {
        if (checklistItemType === WorkorderChecklistItemType.Diagnostic) {
          await futureServiceCreate.mutateAsync({
            futureService: obj,
            diagnosticId: checklistItemId,
          });
        } else if (checklistItemType === WorkorderChecklistItemType.Workorder) {
          await futureServiceCreate.mutateAsync({
            futureService: obj,
            workOrderComplementId: checklistItemId,
          });
        }
      }

      handleCancel();
    } catch {}
  }

  function handleCancel() {
    form.resetFields();
    props.onCancel && props.onCancel();
  }

  return (
    <Modal
      {...props}
      title={title}
      okText="Salvar"
      onOk={handleSubmit}
      onCancel={handleCancel}
      confirmLoading={
        futureServiceCreate.isLoading || futureServiceEdit.isLoading
      }
      destroyOnClose
    >
      <Form form={form}>
        <Row gutter={[16, 16]}>
          <Col span={24}>
            <FloatingFormItem label="Data" name="date" rules={[ruleRequired]}>
              <InputDate
                disabledDate={(date) =>
                  date.isBefore(moment().subtract(1, 'day'))
                }
              />
            </FloatingFormItem>
          </Col>

          <Col span={24}>
            <FloatingFormItem
              label="Descrição"
              name="description"
              rules={[ruleRequired]}
            >
              <Input.TextArea rows={4} />
            </FloatingFormItem>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};

export default ChecklistFutureServiceModalForm;
